module.exports = __webpack_public_path__ + "static/media/OSBM06.8260cc34.jpg";